import type { IconSvgObject } from './types';

const HeartIcon: IconSvgObject = [
  ["path", { d: "M10.9097 22.528C9.0776 21.2899 1.82617 16.0693 1.82617 10.9972C1.82617 8.12837 3.93143 5.80273 6.82617 5.80273C8.32617 5.80273 9.82617 6.30273 11.8262 8.30273C13.8262 6.30273 15.3262 5.80273 16.8262 5.80273C19.7209 5.80273 21.8262 8.12837 21.8262 10.9972C21.8262 16.0693 14.5747 21.2899 12.7427 22.528C12.472 22.7109 12.1528 22.8027 11.8262 22.8027C11.4995 22.8027 11.1803 22.7109 10.9097 22.528Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default HeartIcon;
